<template>
  <v-text-field
    :label="field.label"
    :required="field.is_required"
    v-model="internalValue"
    outlined
    dense
  ></v-text-field>
</template>

<script>
export default {
  props: {
    modelValue: String,
    field: Object,
  },
  emits: ['update:modelValue'],
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        // console.log('Updating modelValue:', value);
        this.$emit('custom-update', value);
      }
    }
  }
};
</script>






  